import { NetworkRegistration } from '@/affiliate-dashboard/components/network-registration';
import { Logo, LogoVariant } from '@/components/base/logo';
import { NavLink } from '@/components/base/nav-link';
import { PageWrapper } from '@/components/base/page-wrapper';
import { ScreenContainer } from '@/components/base/screen-container';
import { faHouse } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute(
  '/(unathenticated)/auth/_layout/network-registration',
)({
  component: () => (
    <PageWrapper title="Register - Monevis">
      <RegistrationPage />
    </PageWrapper>
  ),
  validateSearch: (search: Record<string, unknown>): { ref?: string } => {
    return {
      ref: search.ref ? String(search.ref) : undefined,
    };
  },
});

function RegistrationPage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <ScreenContainer className="relative flex h-full min-h-[100dvh] items-center justify-center overflow-hidden bg-[#040711] dark:bg-[#040711]">
      <div className="absolute top-5 z-10 flex h-6 items-center justify-center text-white sm:h-10">
        <Logo variant={LogoVariant.Monevis} />
      </div>
      <div className="absolute right-5 top-2 z-10 flex items-center justify-center text-white">
        <NavLink
          asChild
          className="flex h-fit p-2 text-base text-default-gray-400"
        >
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.monevis.com/affiliate"
          >
            <FontAwesomeIcon className="block h-6 sm:hidden" icon={faHouse} />
            <span className="hidden sm:block">{t('formLayout.homepage')}</span>
          </a>
        </NavLink>
      </div>
      <div className="z-10">
        <NetworkRegistration />
      </div>
      <div className="absolute left-1/2 top-0 z-0 h-[60%] w-[40%] -translate-y-[90%] rounded-full bg-[#0F62FE66] blur-[90px]" />
      <div className="absolute bottom-0 left-0 z-0 h-[20%] w-[30%] translate-y-[90%] rounded-full bg-[#0f63fe31] blur-[90px]" />
    </ScreenContainer>
  );
}
